import { GoalBasedFinancialPlanAssetLiabilityId } from "@fartherfinance/frontend/api/FinancialPlans/types";

import { AddedAccountOption } from "../../Assets/Types";

export const getFromAccountFromOptions = (
  accountId: GoalBasedFinancialPlanAssetLiabilityId | undefined | null,
  fromAccountOptions: AddedAccountOption[]
): AddedAccountOption | undefined => {
  if (accountId === undefined || accountId === null) {
    return undefined;
  }

  return fromAccountOptions.find((o) => o.value === accountId);
};
